import React, { useState } from "react";
import {
  Accordion,
  Card,
  Button,
  Modal,
  useAccordionToggle,
  AccordionContext,
} from "react-bootstrap";
import moment from "moment";
import SVG from "react-inlinesvg";

export const BusinessHoursMultiplePopup = (props) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState("");

  const openModal = (e) => setOpen(true);

  const closedModal = (e) => setOpen(false);

  const handleToggle = (value) => (e) => {
    setExpanded(value);
  };

  return (
    <React.Fragment>
      <div className="font_18_b mb-4 cursor" onClick={openModal}>
        Hours of Operation
      </div>
      <Modal show={open} onHide={closedModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f16-700">Timings</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          <React.Fragment>
            <div className="business-hours-accordion-view">
              <Accordion>
                <Card>
                  <CustomToggle eventKey="0">Monday</CustomToggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.monday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="1">Tuesday</CustomToggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.tuesday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="2">Wednesday</CustomToggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.wednesday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="3">Thursday</CustomToggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.thursday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="4">Friday</CustomToggle>
                  <Accordion.Collapse eventKey="4">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.friday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="5">Saturday</CustomToggle>
                  <Accordion.Collapse eventKey="5">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.saturday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="6" closed={props.closed}>
                    Sunday
                    {props.closed ? (
                      <span className="enClosedLbl f10-500">Closed</span>
                    ) : null}
                  </CustomToggle>
                  <Accordion.Collapse eventKey="6">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.sunday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </React.Fragment>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

function CustomToggle({ children, eventKey, callback, closed }) {
  const currentEventKey = React.useContext(AccordionContext);
  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => callback && callback(eventKey)
  );
  const isCurrentEventKey = currentEventKey === eventKey;
  return (
    <Accordion.Toggle
      as={Button}
      variant="link"
      eventKey="0"
      className={`accordion-box ${
        isCurrentEventKey ? "active" : "" || closed ? "bg-yellow-light" : ""
      }`}
      onClick={decoratedOnClick}
    >
      {children}
    </Accordion.Toggle>
  );
}

export const HoursofItemAvailability = (props) => {
  //state for modal
  const [open, setOpen] = useState(false);
  const openModal = (e) => setOpen(true);
  const closedModal = (e) => setOpen(false);

  return (
    <React.Fragment>
      <button
        className="editIcon-green"
        type="button"
        onClick={props.disabled ? () => {} : openModal}
      >
        <SVG
          src={require("../../../../assets/images/UserManagement/calendar-white.svg")}
          height="100%"
        />
      </button>
      <Modal show={open} onHide={closedModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <div className="w-100">
            <Modal.Title className="f16-700">
              Hours of Item Availability
            </Modal.Title>
            <div className="displayItemsName f10-400 enRadius5 border-0 d-flex mb-3 mt-4">
              Int Item ID :<div className="idBox enRadius5">{props.id}</div>
            </div>
            <div className="displayItemsName f11-400 enRadius5 mb-4">
              {props.ItemName}
            </div>
            <div className="f16-700">Hours of Operation</div>
          </div>
        </Modal.Header>
        <Modal.Body className="p-0">
          <React.Fragment>
            <div className="business-hours-accordion-view">
              <Accordion>
                <Card>
                  <CustomToggle eventKey="0">Monday</CustomToggle>
                  <Accordion.Collapse eventKey="0">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.monday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="1">Tuesday</CustomToggle>
                  <Accordion.Collapse eventKey="1">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.tuesday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="2">Wednesday</CustomToggle>
                  <Accordion.Collapse eventKey="2">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.wednesday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="3">Thursday</CustomToggle>
                  <Accordion.Collapse eventKey="3">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.thursday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="4">Friday</CustomToggle>
                  <Accordion.Collapse eventKey="4">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.friday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle eventKey="5">Saturday</CustomToggle>
                  <Accordion.Collapse eventKey="5">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.saturday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
                <Card>
                  <CustomToggle
                    eventKey={props.closed ? "" : "6"}
                    closed={props.closed}
                  >
                    Sunday
                    {props.closed && (
                      <span className="enClosedLbl f10-500">Closed</span>
                    )}
                  </CustomToggle>
                  <Accordion.Collapse eventKey="6">
                    <Card.Body>
                      <div className="row all_time_text_section">
                        {props.sunday.map((day, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="col-6 mb-3">
                                <div className="f11-700">
                                  {moment(day.opening_time).format(
                                    "hh:mm A - "
                                  )}
                                  {moment(day.closing_time).format("hh:mm A")}
                                </div>
                                <div className="f10-400 text-gray">
                                  {day.description}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </Card.Body>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </React.Fragment>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
